import React, { useState } from 'react';
import { useData } from '../context/DataContext';
import { CourseCard } from '../components/CourseCard';
import { FilterBar } from '../components/FilterBar';
import { AdminButton } from '../components/AdminButton';
import { SafeHTML } from '../components/SafeHTML';

export function HomePage() {
  const [selectedCategory, setSelectedCategory] = useState('Tout');
  const { courses, settings, loading } = useData();

  const filteredCourses = courses.filter(course => 
    selectedCategory === 'Tout' || course.categories.includes(selectedCategory)
  );

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="text-white">Chargement des formations...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900">
      <AdminButton />
      
      <header className="bg-black shadow-lg border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center h-20">
            <div className="flex items-center gap-4">
              <img
                src={settings.logo}
                alt="Logo"
                className="h-16 w-auto object-contain"
              />
              <h1 className="text-2xl font-bold text-white">
                {settings.pageTitle}
              </h1>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {settings.htmlContent && (
          <div className="mb-8">
            <SafeHTML content={settings.htmlContent} />
          </div>
        )}

        <div className="mb-8">
          <FilterBar
            selectedCategory={selectedCategory}
            onCategoryChange={setSelectedCategory}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredCourses.map(course => (
            <CourseCard key={`course-card-${course.id}`} course={course} />
          ))}
        </div>

        {filteredCourses.length === 0 && (
          <div className="text-center py-12">
            <h3 className="text-xl font-medium text-white mb-2">
              Aucun cours trouvé
            </h3>
            <p className="text-gray-400">
              Essayez une autre catégorie
            </p>
          </div>
        )}
      </main>
    </div>
  );
}